export enum Routes {
  Root = '/',
  Overview = '/overview',
  Checkout = '/checkout',
  Student = '/student',
  Language = '/[language]',
  NotFound = '/404',
}
